
























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class CategoryView extends Vue {
  public items: Common.Category[] = new Array(0);
  public params: Common.CategoryQuery = new Common.CategoryQuery();
  public importQuery = new Common.ImportQuery('区分', 'Category');
  public exportQuery = new Common.ExportQuery('区分', this.params);
  @Prop() public auditNo:string;


  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  public created() {
    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
  }
  public async onCreate(obj: Common.Category) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$api.formatter.clearList(false,'category_1','category_2','category_3','category_4','category_5','category_6',
      'category_11','category_12','category_13','category_14','category_15','category_16','category_21',
      'category_22','category_23','category_24','category_25','category_26','category_31','category_32',
      'category_33','category_41','category_42','category_43','category_101');
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Category):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  // public isEditable(item: Common.Category):boolean {
  //   return item.state == Common.MasterBaseStatus.NotPosted;
  // }
}
